import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { streamActions, callSelectors, nucleusConstants } from '@lifesize/nucleus';
import _find from 'lodash/find';
import PresentationButton from 'components/InCall/InCallFooterButtons/PresentationButton';
import actions from 'actions/PresentationActions';

const mapDispatchToProps = dispatch => ({
  onStopPresentationClick: () => dispatch(streamActions.stopPresentation()),
  initiateScreenShare: streamId => dispatch(streamActions.startPresentation(streamId)),
  showPresentationSelection: () => dispatch(actions.showPresentationSelection())
});

const mapStateToProps = (state, { intl }) => {
  const activeCall = callSelectors.activeCallSelector(state);
  const presenter = _find(activeCall.participants, p => (p.isPresenting));
  const presenterName = presenter ? presenter.name : null;
  return {
    isConnected: activeCall.state === nucleusConstants.CALL_STATE_CONNECTED,
    presenterName,
    isPresenting: activeCall.isPresenting,
    isDisabled: !activeCall.canPresent,
    intl,
  };
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(PresentationButton)
);
